module.exports = __webpack_public_path__ + "img/banner-product.bce38c46.jpg";